export default "__VITE_ASSET__CALnFr0z__"